import React from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
const Hero = ({ jobTitle }) => {
  return (
    <section className="normal-section">
      <Container className="pb-12 pt-32 lg:pt-48">
        <h2 className="text-white text-6xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[12px] ">
          Carrers
        </h2>
        <div className="text-xl text-[#808080] flex flex-wrap items-center gap-x-2 ">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <Link to={"/carrers"} className="capitalize hover:underline">
            Carrers
          </Link>
          <span>|</span>
          <p>Current Jobs</p>
          <span>|</span>
          <p>{jobTitle} </p>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
